import type { RedoMerchantNotificationsRpcClient } from "@redotech/redo-merchant-notifications-rpc/client";
import { createRedoMerchantNotificationsRpcClient } from "@redotech/redo-merchant-notifications-rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoMerchantNotificationsRpcClientContext: Context<
  RedoMerchantNotificationsRpcClient | undefined
> = createContext<RedoMerchantNotificationsRpcClient | undefined>(undefined);
RedoMerchantNotificationsRpcClientContext.displayName =
  "RedoMerchantNotificationsRpcClientContext";

export function RedoMerchantNotificationsRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}) {
  const redoMerchantNotificationsRpcClient = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoMerchantNotificationsRpcClient({
      baseURL: new URL(`${baseUrl}/notifications-rpc`),
      headers: { Authorization: authToken },
    });
  }, [baseUrl, authToken]);

  return (
    <RedoMerchantNotificationsRpcClientContext.Provider
      value={redoMerchantNotificationsRpcClient}
    >
      {children}
    </RedoMerchantNotificationsRpcClientContext.Provider>
  );
}
